import Label from '@mindtickle/label';
import { TEXT_COLORS, TEXT_TYPES, TEXT_MODIFIERS } from '@mindtickle/styles/lib/classNames';
import Icon, { ICON_MAP } from '@mindtickle/icon';

import { SignOutProps } from './types';
import messages from './messages';
import { StyledDropdownActionItemWrapper } from './style';

const SignOut = ({ logout, track, eventName }: SignOutProps) => {
  const onClickHandler = () => {
    track(eventName);
    setTimeout(logout, 0);
  };

  return (
    <StyledDropdownActionItemWrapper className="sign-out-action" data-testid={'button-sign-out'}>
      <Label
        tag="div"
        type={TEXT_TYPES.BODY_MEDIUM_DEFAULT}
        color={TEXT_COLORS.DANGER}
        onClick={onClickHandler}
        message={messages.SIGN_OUT}
        modifier={TEXT_MODIFIERS.TYPOGRAPHY_MOD_STRONG}
        className="dropdown-action-label sign-out-label"
      >
        <Icon type={ICON_MAP.SIGN_OUT} className="sign-out-icon" />
      </Label>
    </StyledDropdownActionItemWrapper>
  );
};

export default SignOut;
